export default "__VITE_ASSET__BiwPLyAe__"